<template>
  <div>
    <div class="operate">
      <van-button
        plain
        size="small"
        type="info"
        v-if="data.status == 0"
        @click.stop="toPay(data)"
      >
        {{ $t("common.immediatelyPay") }}
      </van-button>
      <van-button
        v-if="data.status == 0 || data.status == 1 "
        plain
        size="small"
        type="info"
        @click.stop="orderCancel(data.order_id)"
      >
        {{ $t("life.cancelOrder") }}
      </van-button>
      <van-button
        plain
        size="small"
        type="info"
        v-if="data.status == 1 || data.status == 2"
        @click.stop="_telephone(data.shop_phone)"
      >
        {{ $t("life.contactMerchant") }}
      </van-button>
      <van-button
        plain
        size="small"
        type="info"
        v-if="data.status == 3"
        @click.stop="_telephone(data.delivery_phone)"
      >
        {{ $t("life.contactDeliver") }}
      </van-button>
      <van-button
        plain
        size="small"
        type="info"
        v-if="data.status == 4 && data.is_comment == 0"
        @click.stop="orderEvaluate(data)"
      >
        {{ $t("life.orderEvaluation") }}
      </van-button>
      <van-button
        plain
        size="small"
        type="info"
        v-if="data.status == 4 || data.status == 5 || data.status == 6"
        @click.stop="orderAgain(data)"
      >
        {{ $t("life.oneMoreOrder") }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  name: "",
  components: {},
  data() {
    return {
      timer: '',
    };
  },
  created() {},
  mounted() {
    this.timer = setInterval(this.get, 60*1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {},
  methods: {
    toPay(data) {
      // 去支付
      let vm = this;
      let routeData = {};
      routeData.order_id = data.order_id;
      routeData.total_price = data.total_price;
      routeData.shop_name = data.shop_name;
      vm.$post(
        "/app/order/judgeorder",
        { order_id: data.order_id },
        { loading: true, alert: true }
      ).then(res => {
        console.log("judgeorder", res);
        if (res.code == 0) {
          routeData.time = res.data.time;
          vm.$router.push({
            path: "/payOrder",
            name: "payOrder",
            params: routeData
          });
        } else if (res.code == 40231) {
          vm.$toast(res.msg);
          vm.$emit("request");
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    orderAgain(data) {
      // 再来一单
      let vm = this;
      let params = {};
      params.shop_id = data.shop_id;
      params.order_id = data.order_id;
      vm.$post("/app/order/onemoreOrder", params, { loading: true }).then(
        res => {
          debugger
          console.log("onemoreOrder", res);
          vm.$store.dispatch("SET_SHOPCART_DATA", "delete");
          vm.$store.dispatch("SET_AGAIN_ORDER", "delete");
          vm.$store.dispatch("SET_AGAIN_ORDER", res.prodcut_info);
          vm.$router.push({
            path: "/store",
            name: "store",
            query: { shopId: data.shop_id }
          });
        }
      );
    },
    orderAgain1(data) {
      // 再来一单
      let vm = this;
      let params = {};
      params.shop_id = data.shop_id;
      params.order_id = data.order_id;
      vm.$post("/app/order/onemoreOrder", params, { loading: true }).then(
        res => {
          console.log("onemoreOrder", res);
          let routeData = res[0];
          routeData.shopId = data.shop_id;
          vm.$router.push({
            path: "/submitOrder",
            name: "submitOrder",
            params: routeData
          });
        }
      );
    },
    orderEvaluate(data) {
      // 评价订单
      console.log("orderEvaluate", data);
      this.$emit("update:evaluateData", data);
      this.$emit("update:evaluateFlag", true);
    },
    orderCancel(id) {
      //取消订单
      let vm = this;
      vm.$dialog
        .confirm({
          message: vm.$t("life.cancelOrderTips"),
          confirmButtonText: vm.$t("life.cancelOrder"),
          cancelButtonText: vm.$t("life.thinkAgain")
        })
        .then(() => {
          // on confirm
          vm.cancelOrder(id);
        })
        .catch(() => {
          // on cancel
        });
    },
    cancelOrder(id) {
      // 取消订单
      let vm = this;
      vm.$post(
        "/app/order/cancelOrder",
        { order_id: id },
        { loading: true, alert: true }
      ).then(res => {
        console.log("cancelOrder", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.$emit("regain");
        }
      });
    },


    get() {
      if (this.data.status == 1) {
        let vm = this;
        vm.$post(
          "/app/order/findOrderStatus",
          { order_id: this.data.order_id },
        ).then(res => {
          if (res.status == 2 || res.status == 3) {
            clearInterval(this.timer);
            location.reload();
          }
        });
      }
      else
      {
        clearInterval(this.timer);
      }
    }

  },
  watch: {}
};
</script>

<style scoped lang="less">
.operate {
  button {
    margin-left: 5px;
  }
}
</style>
